import Emitter from '../../services/emitter';
import CONSTANT from '../../constant';
import mElectronApi from '../../util/electron';
import History from '../../util/history';
import Mscratch from '../../services/mscratch';

import ProjectAction from '../project/action';
import {onNew, onOpen} from './project';
import {uploadCode, onClickUploadFirmware} from './common';
import ProjectLocal from '../../services/project/project.local';
import projectModel from '../../model/project.model';

export default (store) => {

    const CONNECT_STATUS = CONSTANT.CONNECT_STATUS;

    let isFirstLoad = true;

    /**
     * 是否连接
     *
     * @returns
     */
    const hasConnected = () => {
        const {connect} = store.getState();
        return connect.status === CONNECT_STATUS.CONNECT_SUCCESS;
    };

    let onOpenTimer = null;
    const onSckOpen = () => {
        if (onOpenTimer !== null) {
            clearTimeout(onOpenTimer);
        }
        onOpenTimer = setTimeout(() => {
            onOpen();
        }, 200);
    };

    let onNewTimer = null;

    /**
     * 新建快捷键处理事件
     */
    const onSckNew = () => {
        if (onNewTimer !== null) {
            clearTimeout(onNewTimer);
        }
        onNewTimer = setTimeout(() => {
            onNew();
        }, 200);
    };

    /**
     * 保存快捷键处理事件
     */
    // const onSckSave = () => onSave();
    const onSckSave = () => {
        Emitter.emit('Shortcutkey', 'save');
    };

    /**
     * 另存为快捷键处理事件
     */
    // const onSckSaveas = () => onSave(true);
    const onSckSaveas = () => {
        Emitter.emit('Shortcutkey', 'saveas');
    };

    // /**
    //  * 撤销快捷键操作
    //  *
    //  */
    // const onSckUndo = onUndo;

    // /**
    //  * 重做快捷键操作
    //  *
    //  */
    // const onSckRedo = onRedo;

    /**
     * 上传代码快捷键执行事件
     *
     */
    const onSckUploadCode = () => {
        if (hasConnected()) {
            uploadCode();
        }
    };

    /**
     * 使用上传代码后，启用 Dtr 重启设备
     *
     */
    const onSckUploadCodeDtr = () => {
        Mscratch.isDtr = true;
        onSckUploadCode();
    };

    /**
     * 快捷键呼出上传固件菜单
     */
    const onSckClickUploadFirmware = onClickUploadFirmware;

    /**
     * 打开文件后执行
     *
     */
    const onOpenLinkedFile = async (filePath) => {
        if(isFirstLoad) {
            projectModel.setSaved();
            isFirstLoad = false;
        }
        store.dispatch(ProjectAction.file({
            path: filePath,
            id: '',
            projectId: '',
            projectType: CONSTANT.PROJECT_TYPE['LOCAL']
        }));
        onOpen(filePath);
    };

    /**
     * 确定保存
     *
     */
    const onConfirmCloseWindow = () => {
        if (projectModel.isSaved()) {
            mElectronApi.closeWindow();
        } else {
            History.push({
                pathname: '/confirm/save/close'
            });
        }
    };

    /**
     * 触发重启设备监听函数
     *
     */
    const onRestart = () => {
        if (projectModel.isSaved()) {
            mElectronApi.restart();
        } else {
            History.push({
                pathname: '/confirm/save/restart'
            });
        }
    };

    /**
     * 触发本地项目读取写入服务
     *
     */
    const onInitLocalServer = () => {
        ProjectLocal.initTimer();
    };

    Emitter.on('RestartApp', onRestart);
    Emitter.on('InitLocalServer', onInitLocalServer);
    Emitter.on('OpenLinkedFile', onOpenLinkedFile);
    Emitter.on('ConfirmCloseWindow', onConfirmCloseWindow);

    Emitter.on('SckNewFile', onSckNew);
    Emitter.on('SckOpenFile', onSckOpen);
    Emitter.on('SckSave', onSckSave);
    Emitter.on('SckSaveas', onSckSaveas);
    // Emitter.on('SckUndo', onSckUndo);
    // Emitter.on('SckRedo', onSckRedo);
    Emitter.on('SckUploadCode', onSckUploadCode);
    Emitter.on('SckUploadCodeDtr', onSckUploadCodeDtr);
    Emitter.on('SckUploadFirmware', onSckClickUploadFirmware);
};